<div class="outer_container" style="height: 100vh; overflow: hidden; font-family: Inter; background-color: #fafdff;">
    <div class="px-4 py-4 common--header" style="border-bottom: 1px solid #DEE8F1; background-color: #FFFFFF;">
        <div class="d-flex justify-content-between align-items-center">
            <div class="ps-2 pe-3 pt-1" *ngIf="profile && profile[0]">
              <span class="h4 f-w-800 fs-18" *ngIf="profile && profile[0]">
                Welcome, {{ profile[0].practice_name ? profile[0].practice_name :
                profile[0].doctor_first_name || profile[0].enterprise_first_name}}

                {{profile[0].practice_name ? '!' :' '+(profile[0].doctor_last_name ||
                profile[0].enterprise_last_name || '')}}{{profile[0].practice_name ? '': '!'}}
              </span>
              <div class="d-inline-flex ms-3 upgrade-btn align-items-center color-change-2x"
                *ngIf="doctorSettings && doctorSettings.subscription_id == 1 && doctorSettings.show_subscription == 1 && profile[0].role_id != 5" tappable (click)="redirectSubscription()">
                <img src="assets/img/png/unlock.png" style="height: 24px; width: 24px">
                <span class="upgrade-text mb-0 pointer ps-2" tappable>Upgrade to unlock features
                </span>
              </div>
            </div>

            <div class="px-3">
            </div>
            <app-notification-icon></app-notification-icon>
          </div>
    </div>
    <div class="row justify-content-center inner_container mt-5"  [style.width]="show_pp_subscription ? '95% !important' : '80% !important'">
        <div class="col-12 fs-16  h2  pb-5 ">
            <h2 class="h2 mb-0 f-w-800 f-c-p-8">
                Choose what you would like to do?
            </h2>
        </div>

        <div class="col-md-12" *ngIf="isFinanceStatusLoading; else multiOptionContent">
          <div class="mc-grid mc-grid--loading" aria-hidden="true">
            <div class="mc-card mc-card--skeleton" *ngFor="let card of [1, 2, 3, 4]">
              <div class="mc-card-art mc-skeleton-art">
                <span class="mc-skeleton-pill"></span>
                <span class="mc-skeleton-icon"></span>
              </div>
              <div class="mc-card-body">
                <span class="mc-skeleton-line mc-skeleton-line--title"></span>
                <span class="mc-skeleton-line"></span>
                <span class="mc-skeleton-line mc-skeleton-line--short"></span>
                <span class="mc-skeleton-cta"></span>
              </div>
            </div>
          </div>
        </div>

        <ng-template #multiOptionContent>
        <div class="col-md-12" *ngIf="mainService.newfinanceUi; else oldMultiOptionUi">
          <div class="mc-grid">
            <div class="mc-card-shell position-relative"
              [ngClass]="[(can_finance == 0 && (profile[0].role_id != 1  || (profile[0].role_id == 1 && locationFilter.name != 'All'))) ? 'disabled' : '', checkChallenge() ? 'mainCard2' : '']">
              <div #cardRef class="mc-card mc-card--featured" [ngClass]="[checkChallenge() ? 'card_2' : 'card2']"
                id="finance_customer" (click)="(((profile[0].role_id == 1)) ? checkUserData($event,'app/finance', 2) : routeMe('app/finance', 2))"
                [ngStyle]="checkChallenge() ? {'border-bottom-left-radius': '0', 'border-bottom-right-radius': '0'} : {}">
                <div class="mc-card-art mc-card-art--finance">
                   <svg width="100%" height="100%" viewBox="0 0 240 160" preserveAspectRatio="xMidYMid slice" class="mc-card-pattern">
                    <circle cx="120" cy="110" r="80" fill="rgba(36,103,227,0.06)"></circle>
                    <circle cx="50" cy="40" r="36" fill="rgba(36,103,227,0.10)"></circle>
                    <circle cx="210" cy="130" r="24" fill="rgba(36,103,227,0.06)"></circle>
                  </svg>
                  <!--<span class="mc-badge-star">&#9733; Most Used</span> -->
                  <button class="mc-learn-link f-Inter" type="button" (click)="(can_finance == 1) && clickToLearn(2, $event)">Learn more</button>
                  <div class="mc-card-icon mc-card-icon--finance">
                    <img src="assets/img/svg/dashboard/finance-customer-icon.svg" alt="" width="24" height="24">
                  </div>
                </div>
                <div class="mc-card-body">
                  <h3 class="mc-card-title">Finance a Customer</h3>
                  <p class="mc-card-desc">Create a new finance contract for a customer who cannot pay in full today.</p>
                  <button class="mc-card-cta mc-card-cta--primary" id="createContract" type="button">
                    Create a Contract
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </button>
                </div>
              </div>

              <div class="banner-container" #bannerRef>
                <div class="challenge-banner"
                  *ngIf="(business_challenge.need_to_create_contract && (business_challenge.need_to_create_contract - business_challenge.contract_this_month)>0)">
                  <img src="assets/img/svg/banner/july-arrow-multi.svg" class="challenge-image"
                    style="height: 45px; width: 45px;">
                  <div style="display: flex; flex-direction: column; margin-left: 11px;">
                    <span style="font-size: 12px; font-family: Inter; font-weight: 500; color: #FFAD36;">
                      {{capitalizeFirstLetter(dynamicMonth)}} Challenge!
                    </span>
                    <span class="challenge-banner__text">
                      Create {{business_challenge.need_to_create_contract - business_challenge.contract_this_month}}
                      more {{(business_challenge.need_to_create_contract - business_challenge.contract_this_month) == 1 ? 'contract' : 'contracts'}} to get
                      {{ '$' + (business_challenge.need_to_create_contract * business_challenge.prize) }} cashback minimum!
                    </span>
                  </div>
                </div>
                <div class="nb_chlng new-business-challenge"
                  *ngIf="business_challenge.is_new_business_challenge && !business_challenge.is_new_business_challenge_achieved && show100DollarChallange == 1">
                  <div>
                    <p class="mb-0">
                      <span>Get $100 Cashback</span>
                      <span>{{daysRemaining}}</span>
                    </p>
                    <span>
                      Add your first contract and enjoy a $100 cashback reward. It’s our way of saying welcome and
                      helping you unlock hidden revenue right from the start!
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="mc-card-shell"
              [ngClass]="[((pp_restricted == 1 || can_finance == 0) && (profile[0].role_id != 1 || (!(locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1))) ? 'disabled' : '']"
              *ngIf="((locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1) || ((locationFilter && locationFilter.name != 'All') && profile[0].role_id == 1 && show_process_payment == 1)  || (profile[0].role_id != 1 && show_process_payment == 1)">
              <div class="mc-card" id="process_payment"
                (click)="((profile[0].role_id == 1) ? checkUserData($event,'app/process-payment/payment', 0) : (pp_restricted == 0 && routeMe('app/process-payment/payment', 0)))">
                <div class="mc-card-art mc-card-art--payment">
                  <svg width="100%" height="100%" viewBox="0 0 240 160" preserveAspectRatio="xMidYMid slice" class="mc-card-pattern">
                    <circle cx="120" cy="110" r="80" fill="rgba(217,119,6,0.06)"></circle>
                    <circle cx="50" cy="40" r="36" fill="rgba(217,119,6,0.10)"></circle>
                    <circle cx="210" cy="130" r="24" fill="rgba(217,119,6,0.06)"></circle>
                  </svg>
                  <button class="mc-learn-link f-Inter" type="button" (click)="(can_finance == 1 && pp_restricted == 0) && clickToLearn(0, $event)">Learn more</button>
                  <div class="mc-card-icon mc-card-icon--payment">
                    <img src="assets/img/svg/dashboard/one-time-payment-icon.svg" alt="" width="24" height="24">
                  </div>
                </div>
                <div class="mc-card-body">
                  <h3 class="mc-card-title">One Time Payment</h3>
                  <div class="mc-card-desc">
                    <p class="f-Inter" *ngIf="((pp_restricted == 1) && ((profile[0].role_id == 1 && locationFilter.name !== 'All') || profile[0].role_id != 1))" (click)="openPopup()">
                      Please use <a>Have us call you back</a> or contact us at support&#64;denefits.com to enable Process Payment feature.
                    </p>
                    <p class="f-Inter" *ngIf="((pp_restricted != 1) || (profile[0].role_id == 1 && locationFilter.name == 'All'))">
                      Securely accept payments in a single transaction from your customer.
                    </p>
                  </div>
                  <button class="mc-card-cta" type="button">
                    <span class="mc-card-cta__label">Process a Payment</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <!-- Legacy subscription card - subscription_flow_type == 0 only -->
            <div class="mc-card-shell"
              [ngClass]="[((can_finance == 0) && (profile[0].role_id != 1 || (!(locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1))) ? 'disabled' : '']"
              *ngIf="subscription_flow_type == 0 && ((((locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1 && show_pp_subscription == 1) || ((locationFilter && locationFilter.name != 'All') && profile[0].role_id == 1 && show_pp_subscription == 1)  || (profile[0].role_id != 1 && show_pp_subscription == 1))) ">
              <div class="mc-card" id="process_payment"
                (click)="((profile[0].role_id == 1) ? checkUserData($event,'app/process-payment/payment', 4) : (routeMe('app/process-payment/payment', 4, undefined, true)))">
                <div class="mc-card-art mc-card-art--subscription">
                  <svg width="100%" height="100%" viewBox="0 0 240 160" preserveAspectRatio="xMidYMid slice" class="mc-card-pattern">
                    <circle cx="120" cy="110" r="80" fill="rgba(124,58,237,0.06)"></circle>
                    <circle cx="50" cy="40" r="36" fill="rgba(124,58,237,0.10)"></circle>
                    <circle cx="210" cy="130" r="24" fill="rgba(124,58,237,0.06)"></circle>
                  </svg>
                  <button class="mc-learn-link f-Inter" type="button" (click)="(can_finance == 1) && clickToLearn(3, $event)">Learn more</button>
                  <div class="mc-card-icon mc-card-icon--subscription">
                    <img src="assets/img/svg/dashboard/subscription-icon.svg" alt="" width="24" height="24">
                  </div>
                </div>
                <div class="mc-card-body">
                  <h3 class="mc-card-title">Subscription</h3>
                  <div class="mc-card-desc">
                    <p class="f-Inter" *ngIf="(((profile[0].role_id == 1 && locationFilter.name !== 'All') || profile[0].role_id != 1))">
                      Set up recurring billing for memberships and ongoing service plans.
                    </p>
                    <p class="f-Inter" *ngIf="((profile[0].role_id == 1 && locationFilter.name == 'All'))">
                      Choose this option to securely accept payments* in one go.
                    </p>
                  </div>
                  <button class="mc-card-cta" type="button">
                    <span class="mc-card-cta__label">Create Subscription</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <!-- Subscription v2 - subscription_flow_type == 1 only -->
            <div class="mc-card-shell"
              [ngClass]="[((can_finance == 0) && (profile[0].role_id != 1 || (!(locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1))) ? 'disabled' : '']"
              *ngIf="subscription_flow_type == 1 && ((((locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1) || ((locationFilter && locationFilter.name != 'All') && profile[0].role_id == 1 && show_pp_subscription == 1)  || (profile[0].role_id != 1 && show_pp_subscription == 1))) ">
              <div class="mc-card" id="subscription_v2"
                (click)="goToSubscriptionV2($event)">
                <div class="mc-card-art mc-card-art--subscription-v2">
                  <svg width="100%" height="100%" viewBox="0 0 240 160" preserveAspectRatio="xMidYMid slice" class="mc-card-pattern">
                    <circle cx="120" cy="110" r="80" fill="rgba(13,148,136,0.06)"></circle>
                    <circle cx="50" cy="40" r="36" fill="rgba(13,148,136,0.10)"></circle>
                    <circle cx="210" cy="130" r="24" fill="rgba(13,148,136,0.06)"></circle>
                  </svg>
                  <button class="mc-learn-link f-Inter" type="button" (click)="(can_finance == 1) && clickToLearn(3, $event)">Learn more</button>
                  <!-- <span class="mc-badge-star mc-badge-star--new">New</span> -->
                  <div class="mc-card-icon mc-card-icon--subscription-v2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 12a9 9 0 1 1-9-9c2.5 0 4.8 1 6.5 2.6"></path>
                      <path d="M21 3v6h-6"></path>
                      <path d="M12 7v5l3 2"></path>
                    </svg>
                  </div>
                </div>
                <div class="mc-card-body">
                  <h3 class="mc-card-title">Subscription</h3>
                  <div class="mc-card-desc">
                    <p class="f-Inter" *ngIf="(((profile[0].role_id == 1 && locationFilter.name !== 'All') || profile[0].role_id != 1))">
                      Set up recurring billing for memberships and ongoing service plans.
                    </p>
                    <p class="f-Inter" *ngIf="((profile[0].role_id == 1 && locationFilter.name == 'All'))">
                      Choose this option to securely accept payments* in one go.
                    </p>
                  </div>
                  <button class="mc-card-cta" type="button">
                    <span class="mc-card-cta__label">Create Subscription</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div class="mc-card-shell" [ngClass]="[(can_finance == 0 && (profile[0].role_id != 1  || (profile[0].role_id == 1 && locationFilter.name != 'All'))) ? 'disabled' : '']">
              <div class="mc-card" id="account_receivable"
                (click)="number_of_record_processed==0?((profile[0].role_id == 1) ? checkUserData($event,'app/accounts-receivable/send-invoice', 1) : routeMe('app/accounts-receivable/send-invoice', 1)):''">
                <div class="mc-card-art mc-card-art--receivable">
                  <svg width="100%" height="100%" viewBox="0 0 240 160" preserveAspectRatio="xMidYMid slice" class="mc-card-pattern">
                    <circle cx="120" cy="110" r="80" fill="rgba(5,150,105,0.06)"></circle>
                    <circle cx="50" cy="40" r="36" fill="rgba(5,150,105,0.10)"></circle>
                    <circle cx="210" cy="130" r="24" fill="rgba(5,150,105,0.06)"></circle>
                  </svg>
                  <button class="mc-learn-link f-Inter" type="button" *ngIf="show_ar == 1" (click)="(can_finance == 1 && show_ar == 1) && clickToLearn(1, $event)">Learn more</button>
                  <div class="mc-card-icon mc-card-icon--receivable">
                    <img src="assets/img/svg/dashboard/accounts-receivable-icon.svg" alt="" width="24" height="24">
                  </div>
                </div>
                <div class="mc-card-body">
                  <h3 class="mc-card-title">Accounts Receivable</h3>
                  <p class="mc-card-desc f-Inter">Recover overdue invoices with structured, automated payment plans.</p>
                  <button class="mc-card-cta" type="button">
                    <span class="mc-card-cta__label">Add a Receivable</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </ng-template>

        <ng-template #oldMultiOptionUi>
          <div class="col-md-12">
            <div class="row finnaceCard--row justify-content-center">
              <!-- Card 1 -->
              <div class="col-md-6 col-sm-12 mb-4 h-auto"
                [ngClass]="[show_pp_subscription ? 'col-lg-3' : 'col-lg-4', (((pp_restricted == 1 || can_finance == 0)) &&  (profile[0].role_id != 1 || (!(locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1))) ? 'disabled' : '']" *ngIf="((locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1) || ((locationFilter && locationFilter.name != 'All') && profile[0].role_id == 1 && show_process_payment == 1)  || (profile[0].role_id != 1 && show_process_payment == 1)">
                <div class="card card1 h-100 d-flex flex-column" id="process_payment"
                  (click)="((profile[0].role_id == 1) ? checkUserData($event,'app/process-payment/payment', 0) : (pp_restricted == 0 && routeMe('app/process-payment/payment', 0)))">
                  <div class="d-inline-flex mt-3" [ngClass]="{'pt-5': (cookie == 'de')}">
                    <p class="learn f-Inter" (click)="(can_finance == 1 && pp_restricted == 0) && clickToLearn(0, $event)">Learn more</p>
                  </div>
                  <div class="card-length d-flex flex-column" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                    <div class="icon_box" [ngClass]="[((pp_restricted == 1) && ((profile[0].role_id == 1 && locationFilter.name !== 'All') || profile[0].role_id != 1)) ? 'img1_disabled' : 'img1']"></div>
                    <div class="head_1 f-Inter">No Fee Payment Processing</div>
                    <div class="defination" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                      <p class="f-Inter" *ngIf="((pp_restricted == 1) && ((profile[0].role_id == 1 && locationFilter.name !== 'All') || profile[0].role_id != 1))" (click)="openPopup()">
                        Please use <a style="color: #1581E5;position: relative;">
                          <u> Have us call you back </u></a> or contact us at support&#64;denefits.com to enable Process
                        Payment feature.
                      </p>
                      <p class="f-Inter" *ngIf="((pp_restricted != 1) || (profile[0].role_id == 1 && locationFilter.name == 'All'))">Choose this option to securely accept payments* in one
                        go.</p>
                    </div>
                  </div>
                  <div class="btn--wrapper mt-auto">
                    <button class="btn btn-primary" style="margin-bottom: 10px;" type="button">
                      Process a Payment
                    </button>
                  </div>
                </div>
              </div>

              <!-- Legacy subscription card - subscription_flow_type == 0 only -->
              <div class="col-md-6 col-sm-12 mb-4 h-auto"
                [ngClass]="[show_pp_subscription ? 'col-lg-3' : 'col-lg-4', ((( can_finance == 0)) &&  (profile[0].role_id != 1 || (!(locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1))) ? 'disabled' : '']"
                *ngIf="subscription_flow_type == 0 && ((((locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1 && show_pp_subscription == 1) || ((locationFilter && locationFilter.name != 'All') && profile[0].role_id == 1 && show_pp_subscription == 1)  || (profile[0].role_id != 1 && show_pp_subscription == 1))) ">
                <div class="card card1 h-100 d-flex flex-column" id="process_payment"
                  (click)="((profile[0].role_id == 1) ? checkUserData($event,'app/process-payment/payment', 4) : (routeMe('app/process-payment/payment', 4, undefined, true)))">
                  <div class="d-inline-flex mt-3" [ngClass]="{'pt-5': (cookie == 'de')}">
                    <p class="learn f-Inter" (click)="(can_finance == 1) && clickToLearn(3, $event)">Learn more
                    </p>
                  </div>
                  <div class="card-length d-flex flex-column" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                    <div class="icon_box"
                      [ngClass]="[false ? 'img4_disabled' : 'img4']">
                    </div>
                    <div class="head_1 f-Inter">Subscription</div>
                    <div class="defination" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                      <p class="f-Inter"
                        *ngIf="(((profile[0].role_id == 1 && locationFilter.name !== 'All') || profile[0].role_id != 1))"
                        >
                        Create and manage recurring payments for your service. Automatically charge customers on a fixed schedule.
                      </p>
                      <p class="f-Inter" *ngIf="((profile[0].role_id == 1 && locationFilter.name == 'All'))">
                        Choose this option to securely accept payments* in one
                        go.</p>
                    </div>
                  </div>
                  <div class="btn--wrapper mt-auto">
                    <button class="btn btn-primary" style="margin-bottom: 10px;" type="button">
                      Create Subscription
                    </button>
                  </div>
                </div>
              </div>

              <!-- Subscription v2 - subscription_flow_type == 1 only -->
              <div class="col-md-6 col-sm-12 mb-4 h-auto"
                [ngClass]="[show_pp_subscription ? 'col-lg-3' : 'col-lg-4', ((( can_finance == 0)) &&  (profile[0].role_id != 1 || (!(locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1))) ? 'disabled' : '']"
                *ngIf="subscription_flow_type == 1 && ((((locationFilter && locationFilter.name == 'All') && profile[0].role_id == 1) || ((locationFilter && locationFilter.name != 'All') && profile[0].role_id == 1 && show_pp_subscription == 1)  || (profile[0].role_id != 1 && show_pp_subscription == 1))) ">
                <div class="card card1 h-100 d-flex flex-column" id="process_payment"
                  (click)="goToSubscriptionV2($event)">
                  <div class="d-inline-flex mt-3" [ngClass]="{'pt-5': (cookie == 'de')}">
                    <p class="learn f-Inter" (click)="(can_finance == 1) && clickToLearn(3, $event)">Learn more
                    </p>
                  </div>
                  <div class="card-length d-flex flex-column" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                    <div class="icon_box"
                      [ngClass]="[false ? 'img4_disabled' : 'img4']">
                    </div>
                    <div class="head_1 f-Inter">Subscription</div>
                    <div class="defination" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                      <p class="f-Inter"
                        *ngIf="(((profile[0].role_id == 1 && locationFilter.name !== 'All') || profile[0].role_id != 1))"
                        >
                        Create and manage recurring payments for your service. Automatically charge customers on a fixed schedule.
                      </p>
                    </div>
                  </div>
                  <div class="btn--wrapper mt-auto">
                    <button class="btn btn-primary" style="margin-bottom: 10px;" type="button">
                      Create Subscription
                    </button>
                  </div>
                </div>
              </div>

              <!-- Card 2 -->
              <div class="col-md-6 col-sm-12 mb-4 h-auto position-relative"
                [ngClass]="[show_pp_subscription ? 'col-lg-3' : 'col-lg-4', (can_finance == 0 && (profile[0].role_id != 1  || (profile[0].role_id == 1 && locationFilter.name != 'All'))) ? 'disabled' : '', checkChallenge() ? 'mainCard2' : '']">
                <div #cardRef class="card h-100 d-flex flex-column" [ngClass]="[checkChallenge() ? 'card_2' : 'card2']"
                  id="finance_customer" (click)="(((profile[0].role_id == 1)) ? checkUserData($event,'app/finance', 2) : routeMe('app/finance', 2))"
                  style="justify-content: flex-start;"  [ngStyle]="checkChallenge() ? {'border-bottom-left-radius': '0', 'border-bottom-right-radius': '0'} : {}">
                  <div class="d-inline-flex mt-3" [ngClass]="{'pt-5': (cookie == 'de')}">
                    <p class="learn f-Inter" (click)="(can_finance == 1) && clickToLearn(2, $event)">Learn more</p>
                  </div>
                  <div class="card-length d-flex flex-column" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                    <div>
                      <div class="icon_box img2"></div>
                    </div>
                    <div class="head_1 f-Inter">Finance a Customer</div>
                    <div class="defination" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                      <p class="f-Inter">Create a new finance contract for a customer who cannot pay in full today.</p>
                    </div>
                  </div>
                  <div class="btn--wrapper mt-auto">
                    <button class="btn btn-primary" style="margin-bottom: 10px;" id="createContract"  type="button"
                      >Create a Contract</button>
                  </div>
                </div>

                <!-- Banner positioned below the Card using absolute -->
                <div class="banner-container" #bannerRef style="position: absolute; margin-top: -5px; border-bottom-left-radius: 6px; border-bottom-right-radius: 6px">
                  <!-- background-image: url('assets/img/svg/banner/small-june-banner-img.svg') -->
                  <div
                    style="background-color: #E4E3FF; display: flex;align-items: center;justify-content: space-around;height: 72px;padding: .5em;"
                    *ngIf="(business_challenge.need_to_create_contract && (business_challenge.need_to_create_contract - business_challenge.contract_this_month)>0)">
                    <img src="assets/img/svg/banner/Nov-target-arrow.svg" class="challenge-image"
                      style="height: 45px; width: 45px;">
                    <div style="display: flex; flex-direction: column; margin-left: 11px;">
                      <span style="font-size: 12px; font-family: Inter; font-weight: 500; color: #000;">
                        {{capitalizeFirstLetter(dynamicMonth)}} Denefits Challenge!
                      </span>
                      <span style="font-size: 14px; font-family: Inter; font-weight: 500; color: #4F46D8;">
                        Create {{business_challenge.need_to_create_contract - business_challenge.contract_this_month}}
                        more  {{(business_challenge.need_to_create_contract - business_challenge.contract_this_month) == 1 ? 'contract' : 'contracts'}} to get
                        {{ '$' + (business_challenge.need_to_create_contract * business_challenge.prize) }} cashback minimum!
                      </span>
                    </div>
                  </div>
                  <div
                    style="display: flex; align-items: center; justify-content: space-around; padding: 1.5em; margin: -9px -6px -15px -6px;"
                    class="nb_chlng"
                    *ngIf="business_challenge.is_new_business_challenge && !business_challenge.is_new_business_challenge_achieved && show100DollarChallange == 1">
                    <div>
                      <p class="mb-0">
                        <span style="font-size: 16px; font-family: Inter; font-weight: 600; color: #000000;">Get $100 Cash
                          Back</span>
                        <span
                          style="font-size: 16px; font-family: Inter; font-weight: 600; color: #C45D00; float: right;">{{daysRemaining}}</span>
                      </p>
                      <span
                        style="font-size: 13px; font-family: Inter; font-weight: 500; color: #000000; text-align: justify;">
                        Add your first contract and enjoy a $100 cashback reward. It’s our way of saying welcome and
                        helping you unlock hidden revenue right from the start!
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card 3 -->
              <div class="col-md-6 col-sm-12 mb-4 h-auto" [ngClass]="[show_pp_subscription ? 'col-lg-3' : 'col-lg-4', (can_finance == 0 && (profile[0].role_id != 1  || (profile[0].role_id == 1 && locationFilter.name != 'All'))) ? 'disabled' : '']">
                <div class="card card3 h-100 d-flex flex-column" id="account_receivable"
                  (click)="number_of_record_processed==0?((profile[0].role_id == 1) ? checkUserData($event,'app/accounts-receivable/send-invoice', 1) : routeMe('app/accounts-receivable/send-invoice', 1)):''">
                  <div class="d-inline-flex mt-3" [ngClass]="{'pt-5': (cookie == 'de')}" *ngIf="show_ar == 1">
                    <p class="learn f-Inter" (click)="(can_finance == 1 && show_ar == 1) && clickToLearn(1, $event)">Learn more</p>
                  </div>
                  <div class="card-length d-flex flex-column" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                    <div class="icon_box img3"></div>
                    <div class="head_1 f-Inter">Accounts Receivable</div>
                    <div class="defination" [ngClass]="[!checkChallenge() ? ' flex-grow-1' : '']">
                      <p class="f-Inter">Choose this if you want to run your debt recovery on autopilot.</p>
                    </div>
                  </div>
                  <div class="btn--wrapper mt-auto">
                    <button class="btn btn-primary" style="margin-bottom: 10px;" type="button"
                      >Add AR
                      Accounts</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <div class="col-12" *ngIf="can_finance == 0 && (profile[0].role_id != 1  || (profile[0].role_id == 1 && locationFilter.name != 'All'))">
            <p class="wran_info"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.7035 3.74857L2.4557 17.9978C2.32372 18.2259 2.25412 18.4846 2.25391 18.748C2.25369 19.0115 2.32286 19.2703 2.45446 19.4986C2.58605 19.7268 2.77544 19.9163 3.00355 20.0481C3.23167 20.1799 3.49047 20.2493 3.75391 20.2493H20.2495C20.5129 20.2493 20.7717 20.1799 20.9998 20.0481C21.2279 19.9163 21.4173 19.7268 21.5489 19.4986C21.6805 19.2703 21.7497 19.0115 21.7495 18.748C21.7492 18.4846 21.6796 18.2258 21.5477 17.9978L13.2999 3.74857C13.1681 3.52093 12.9788 3.33193 12.751 3.20055C12.5231 3.06916 12.2647 3 12.0017 3C11.7387 3 11.4803 3.06916 11.2524 3.20055C11.0245 3.33193 10.8352 3.52093 10.7035 3.74857Z" fill="#FFAD36" stroke="#FFAD36" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 9.75V13.5" stroke="#222325" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.0781 16.875C13.0781 17.4704 12.5954 17.9531 12 17.9531C11.4046 17.9531 10.9219 17.4704 10.9219 16.875C10.9219 16.2796 11.4046 15.7969 12 15.7969C12.5954 15.7969 13.0781 16.2796 13.0781 16.875Z" fill="#222325" stroke="#222325" stroke-width="0.09375"/>
                </svg> Please contact Denefits at <a href="mailto:support@denefits.com">support&#64;denefits.com</a> to verify your account</p>
        </div>

    </div>
</div>

<app-bg-proposal-progress [dataFromParentElement]="multiCustomerData" (data_from_bg_proposal)="set_values_for_background_processing_data($event)"></app-bg-proposal-progress>
